import styled, { css } from "styled-components";
import Block from "components/layout/Block";
import Link from "components/layout/Link";
import { useRef, useState, useEffect } from "react";
import sharedObservers from "utils/sharedObservers";

const Bottom = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	line-height: 1.25rem;
	text-align: center;
	width: 100%;
`;

const LinkStyled = styled(Link)`
	width: 100%;
	height: 100%;

	border-radius: ${({ theme: { borderRadius } }) => borderRadius.panel};
	background-color: transparent;

	&:hover,
	&:focus {
		background-color: ${({ theme: { colors } }) => colors.itemsHover};
	}

	${({ $withShadowAndBorder }) => {
		return (
			$withShadowAndBorder &&
			css`
				border-radius: var(--dz-sys-card-border-radius);
				box-shadow: var(--dz-sys-card-shadow);
				border: 1px solid var(--dz-sys-card-shadow-border);
			`
		);
	}}
`;

const StyledContainer = styled(Block)`
	${({ $withShadowAndBorder }) => {
		return (
			$withShadowAndBorder &&
			css`
				border-radius: var(--dz-sys-card-border-radius);
				box-shadow: var(--dz-sys-card-shadow);
				border: 1px solid var(--dz-sys-card-shadow-border);
			`
		);
	}}
`;

const TileOptimized = ({
	id,
	to = false,
	avatarComponent,
	loginComponent = null,
	additionalLine = null,
	noPaddingAndMarginTile = false,
	withShadowAndBorder = false,
}) => {
	const [inView, setInView] = useState(true);
	const containerRef = useRef(null);
	const lastHeightRef = useRef(null);

	useEffect(() => {
		if (!containerRef.current) return;

		const cleanupIntersection = sharedObservers.observeIntersection(
			containerRef.current,
			(isIntersecting) => {
				if (!isIntersecting && containerRef.current) {
					lastHeightRef.current =
						containerRef.current.offsetHeight ||
						lastHeightRef.current;
				}
				setInView(isIntersecting);
			}
		);

		return () => {
			cleanupIntersection();
		};
	}, [id]);

	const renderContent = () => (
		<Bottom>
			{avatarComponent}
			<Block mt={2} style={{ maxWidth: "100%" }}>
				{loginComponent}
			</Block>
			{additionalLine}
		</Bottom>
	);

	if (to) {
		return (
			<LinkStyled to={to} $withShadowAndBorder={withShadowAndBorder}>
				<Block
					flex
					column
					alignCenter
					p={noPaddingAndMarginTile ? 0 : 1}
					pt={noPaddingAndMarginTile ? 0 : 3}
					ref={containerRef}
					style={{
						maxWidth: "100%",
						minHeight: inView
							? "auto"
							: lastHeightRef.current > 0
							? lastHeightRef.current
							: "218px", // standard component height
					}}
				>
					{inView && renderContent()}
				</Block>
			</LinkStyled>
		);
	} else {
		return (
			<StyledContainer
				ref={containerRef}
				style={{
					minHeight: inView
						? "auto"
						: lastHeightRef.current > 0
						? lastHeightRef.current
						: "218px", // standard component height
				}}
				flex
				column
				alignCenter
				p={noPaddingAndMarginTile ? 0 : 1}
				$withShadowAndBorder={withShadowAndBorder}
			>
				{inView && renderContent()}
			</StyledContainer>
		);
	}
};

export default TileOptimized;
